import React from 'react';
import SimplePageHeader from '@/header/SimplePageHeader';
import NikeTvTabs from '@/header/NikeTvTabs';

function NikeTvHeader({ active }) {
    return (
        <SimplePageHeader pageFixerClassName="tabs">
            <NikeTvTabs active={active} />
        </SimplePageHeader>
    );
}

export default NikeTvHeader;
